import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.function.bind.js";
var _excluded = ["isActive", "outline"];
var _templateObject;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import styled from '@emotion/styled';
import { Button } from '@material-ui/core';
import React from 'react';
import { Typography } from "../Typography";
import { BLUE, GRAY, WHITE } from "../../constants/colors/hex";
var BLUE_IDX = 19;
var GRAY_IDX = 20;

// NOTE: the hover + focus states should be baked into the button component but it's not
// implemented there.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export var ToggleStyled = styled(function (_ref) {
  var isActive = _ref.isActive,
    outline = _ref.outline,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Button, _extends({}, props, {
    color: "primary"
  }));
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  && {\n    align-items: center;\n    background-color: ", ";\n    border: ", ";\n    color: ", ";\n    border-radius: 100px;\n    display: flex;\n    padding: 8px 16px;\n\n    &:hover {\n      background-color: ", ";\n    }\n\n    &:focus {\n      background-color: ", ";\n    }\n  }\n"])), function (props) {
  return props.isActive ? BLUE[BLUE_IDX] : !props.outline ? GRAY[GRAY_IDX] : WHITE;
}, function (props) {
  return !props.outline ? '0' : props.isActive ? "1px solid ".concat(BLUE[10]) : "1px solid ".concat(GRAY[15]);
}, function (props) {
  return props.isActive ? BLUE[5] : GRAY[10];
}, function (props) {
  return props.isActive ? BLUE[BLUE_IDX - 1] : !props.outline ? GRAY[GRAY_IDX - 1] : GRAY[21];
}, function (props) {
  return props.isActive ? BLUE[BLUE_IDX - 2] : !props.outline ? GRAY[GRAY_IDX - 2] : GRAY[20];
});
export var TextStyled = styled(Typography)({
  fontFamily: 'Open Sans'
});